import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { KeyFeature } from "@/components/Product/Feature/KeyFeatures/keyFeatures.types";

type FeatureContextValue = {
    feature: KeyFeature;
};

type FeatureContextProviderProps = {
    feature: KeyFeature;
    children: ReactNode;
};

export const FeatureContext = createContext<FeatureContextValue | undefined>(
    undefined
);

export const FeatureContextProvider = ({
    feature,
    children
}: FeatureContextProviderProps) => {
    return (
        <FeatureContext
            value={{
                feature: feature
            }}
        >
            {children}
        </FeatureContext>
    );
};

export const useFeatureContext = () => {
    const context = use<FeatureContextValue | undefined>(FeatureContext);

    if (!isDefined(context)) {
        throw new Error(`${FeatureContext.displayName} is undefined.`);
    }

    return context;
};
